import { ComponentPropsWithoutRef, forwardRef, useState } from 'react';
import { TextField } from 'melp-design/components';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

type Props = Omit<
  ComponentPropsWithoutRef<typeof TextField>,
  'type' | 'multiline' | 'emoji' | 'secure'
>;

export const PasswordInput = forwardRef<HTMLInputElement, Props>(
  ({ ...textInputProps }, forwardedRed) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
      <TextField
        {...textInputProps}
        type={isVisible ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setIsVisible((current) => !current)}
              >
                {isVisible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        ref={forwardedRed}
      />
    );
  },
);

PasswordInput.displayName = 'PasswordInput';
